<template id="modalbox">
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!--img class="img-responsive" src="images/popthumb2.png" alt=""-->
          <div class="icon">
            <!-- Icon Loading -->
            <i :class="'fa fa-fw '+(icon==null?'fa-refresh fa-spin':icon)"></i>
            <!-- Icon Done -->
            <!--i class="fa fa-check fa-fw"></i-->
          </div>
          <h4 class="modal-title" id="myModalLabel" v-html="msg"></h4>
        </div>
        <div class="modal-body">
          <div class="centerbutton">
            <input v-if="button != null" class="redButon" :value="button" type="submit" v-on:click="close()">
            <input v-for="(btn, bidx) in buttons" class="redButon" :value="btn.value" type="submit" v-on:click="doButton(btn)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import utils from './Utils.vue'
import modalBox from './ModalBox.vue'

export default {
  extends: modalBox,
  name: 'statusModal',
  created:function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StatusModal.vue